import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ModeBadge } from "@/components/figures/ModeBadge";
import { fieldNotes } from "@/data/fieldNotes";

function formatDate(iso: string) {
  const d = new Date(`${iso}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}

function oneLine(text: string) {
  return text.length > 140 ? `${text.slice(0, 140).trimEnd()}...` : text;
}

export function FieldNotesSection() {
  const notes = fieldNotes
    .filter((n) => n.approved && !n.upcoming)
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 3);

  if (notes.length === 0) return null;

  return (
    <section className="border-t border-border/60 py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <h2 className="font-display text-3xl font-bold text-foreground sm:text-4xl">
          Field Notes
        </h2>
        <ul className="mt-8 grid gap-5 sm:grid-cols-3">
          {notes.map((note) => (
            <li
              key={note.id}
              className="rounded-xl border border-border/60 bg-card/60 p-5"
            >
              <div className="flex flex-wrap items-center gap-3">
                <time
                  dateTime={note.date}
                  className="font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground"
                >
                  {formatDate(note.date)}
                </time>
                <ModeBadge mode={note.mode} />
              </div>
              <h3 className="mt-3 font-display text-base font-bold leading-snug text-foreground">
                {note.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {oneLine(note.body)}
              </p>
            </li>
          ))}
        </ul>
        <Link
          to="/field-notes"
          className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-liberty-gold hover:opacity-80"
        >
          All field notes <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
